import React, { type LabelHTMLAttributes, useMemo } from 'react';

import { ReactComponent as SearchIcon } from '@pkg/assets/icons/v2/search.svg';

import './Label.scss';

interface YatPickerFormLabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
    muted: boolean;
}

const YatPickerFormLabel = ({ muted = false, ...props }: YatPickerFormLabelProps) => {
    const classNames = useMemo(() => {
        let classNames = 'yat-picker-form-label';
        if (muted) classNames += ` yat-picker-form-label--muted`;

        return classNames;
    }, [muted]);

    return (
        <label {...props} className={classNames}>
            <SearchIcon className="yat-picker-form-label__icon" />
            <span className="yat-picker-form-label__sr-only">Search emoji</span>
        </label>
    );
};

export default YatPickerFormLabel;
